import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getWeddingPartyMemberRole } from '../../manage/website/entities/WeddingPartyMemberRoles';
import { getWeddingPageByType } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import { chunkArray } from '../../common/ui/templateHelpers';

class WeddingParty extends Component {
  componentDidMount() {
    const { getWeddingParty, forPreview } = this.props;
    if (!forPreview) {
      getWeddingParty();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  render() {
    const { weddingParty, orderedIds, page, forPreview, busy } = this.props;
    return (
      <div id="wedding-party-page" className="container">
        {page && !busy && (
          <div className={['cms-page-header', ((!page.description && !page.header_image_url) || !page.title ? 'flex-container' : null)].join(' ')}>
            <div className="cms-header-accent-top-left" />
            <div className="cms-header-accent-top-right" />
            <div className="cms-header-accent-bottom-left" />
            <div className="cms-header-accent-bottom-right" />
            <h1 className="for-small-laptops">{page.title}</h1>
            {page.header_image_url && (
              <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
            )}
            {page.description && (
              <p className="page-description">{page.description}</p>
            )}
          </div>
        )}
        <div className="entity-sections wedding-party-sections">
          <div className="entity-sections-accent-top-left" />
          <div className="entity-sections-accent-top-right" />
          <div className="entity-sections-accent-bottom-left" />
          <div className="entity-sections-accent-bottom-right" />
          {forPreview && weddingParty && chunkArray(orderedIds, 2).map((memberIdChunk, idx) => (
            <div className="entity-section-row" key={idx}>
              {memberIdChunk.map((memberId, i) => (
                <div className="entity-section wedding-party-section" key={i}>
                  <div className="entity-section-title wedding-party-section-title">
                    {weddingParty[memberId].image_url && (
                      <div className="member-photo-wrapper">
                        <div className="member-photo" style={{ backgroundImage: `url(${weddingParty[memberId].image_url})` }} />
                      </div>
                    )}
                    <h2 className="member-name">
                      {weddingParty[memberId].name}
                    </h2>
                    <h4 className="member-role">
                      {weddingParty[memberId].role === 'CUSTOM' ? weddingParty[memberId].custom_role : getWeddingPartyMemberRole(weddingParty[memberId].role)}
                    </h4>
                  </div>
                  <div className="entity-section-description wedding-party-section-description">
                    <p>
                      {weddingParty[memberId].description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
          {!forPreview && weddingParty && chunkArray(weddingParty, 2).map((memberChunk, idx) => (
            <div className="entity-section-row" key={idx}>
              {memberChunk.map((member, i) => (
                <div className="entity-section wedding-party-section" key={i}>
                  <div className="entity-section-title wedding-party-section-title">
                    {member.image_url && (
                      <div className="member-photo-wrapper">
                        <div className="member-photo" style={{ backgroundImage: `url(${member.image_url})` }} />
                      </div>
                    )}
                    <h2 className="member-name">
                      {member.name}
                    </h2>
                    <h4 className="member-role">
                      {member.role === 'CUSTOM' ? member.custom_role : getWeddingPartyMemberRole(member.role)}
                    </h4>
                  </div>
                  <div className="entity-section-description wedding-party-section-description">
                    <p>
                      {member.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
          {((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && weddingParty && weddingParty.length === 0)) && (
            <p className="text-center empty-entity-text">
              Wedding party coming soon!
            </p>
          )}
        </div>
      </div>
    );
  }
}

WeddingParty.propTypes = {
  weddingParty: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getWeddingParty: PropTypes.func,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({}).isRequired,
  busy: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => (
  {
    weddingParty: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
    orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
    page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
    busy: state.publicWebsite.busy
  }
);

const mapDispatchToProps = dispatch => (
  {
    getWeddingParty: () => {
      dispatch(getWeddingPageByType('wedding_party'));
    },
    unloadEntities: () => dispatch(resetEntities())
  }
);

const WeddingPartyContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeddingParty);

export default WeddingPartyContainer;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/WeddingParty.jsx
 **/